/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResult,
  NotFoundErrorResult,
  Result,
  ResultOfTrustDetailsViewModel,
  TrustDetailsViewModel,
  ValidationErrorResult,
} from '../models';
import {
    ErrorResultFromJSON,
    ErrorResultToJSON,
    NotFoundErrorResultFromJSON,
    NotFoundErrorResultToJSON,
    ResultFromJSON,
    ResultToJSON,
    ResultOfTrustDetailsViewModelFromJSON,
    ResultOfTrustDetailsViewModelToJSON,
    TrustDetailsViewModelFromJSON,
    TrustDetailsViewModelToJSON,
    ValidationErrorResultFromJSON,
    ValidationErrorResultToJSON,
} from '../models';

export interface TrustDetailsGetTrustDetailsRequest {
    proposalId: number;
}

export interface TrustDetailsPostRequest {
    proposalId: number;
    trustDetailsViewModel: TrustDetailsViewModel;
}

/**
 * 
 */
export class TrustDetailsApi extends runtime.BaseAPI {

    /**
     * Get personal details for a trust.
     */
    async trustDetailsGetTrustDetailsRaw(requestParameters: TrustDetailsGetTrustDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfTrustDetailsViewModel>> {
        if (requestParameters.proposalId === null || requestParameters.proposalId === undefined) {
            throw new runtime.RequiredError('proposalId','Required parameter requestParameters.proposalId was null or undefined when calling trustDetailsGetTrustDetails.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/personal-details/trust/{proposalId}`.replace(`{${"proposalId"}}`, encodeURIComponent(String(requestParameters.proposalId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfTrustDetailsViewModelFromJSON(jsonValue));
    }

    /**
     * Get personal details for a trust.
     */
    async trustDetailsGetTrustDetails(requestParameters: TrustDetailsGetTrustDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfTrustDetailsViewModel> {
        const response = await this.trustDetailsGetTrustDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Posts the party\'s personal details for a trust.
     */
    async trustDetailsPostRaw(requestParameters: TrustDetailsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Result>> {
        if (requestParameters.proposalId === null || requestParameters.proposalId === undefined) {
            throw new runtime.RequiredError('proposalId','Required parameter requestParameters.proposalId was null or undefined when calling trustDetailsPost.');
        }

        if (requestParameters.trustDetailsViewModel === null || requestParameters.trustDetailsViewModel === undefined) {
            throw new runtime.RequiredError('trustDetailsViewModel','Required parameter requestParameters.trustDetailsViewModel was null or undefined when calling trustDetailsPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/personal-details/trust/{proposalId}`.replace(`{${"proposalId"}}`, encodeURIComponent(String(requestParameters.proposalId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TrustDetailsViewModelToJSON(requestParameters.trustDetailsViewModel),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultFromJSON(jsonValue));
    }

    /**
     * Posts the party\'s personal details for a trust.
     */
    async trustDetailsPost(requestParameters: TrustDetailsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Result> {
        const response = await this.trustDetailsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
